// extracted by mini-css-extract-plugin
export var collapsedSummary = "_s2-0";